import BaseAPI from "./BaseAPI";
import { mapsRoute } from "../routes";

export default class MapsAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, mapsRoute, "maps");
    }

    async Geocode(address) {
        return this._request("get", this._url(`/geocode?address=${address}`));
    }

    async Static(size) {
        return this._request("get", this._url(`/static?size=${size}`), null, {
            rawData: true,
            responseType: "blob"
        });
    }
}
